import { createSlice } from '@reduxjs/toolkit';
import * as AllActions from '../action';
import ActionType from '../actionType';
import { isNull } from 'lodash';

const initialState: any = {
  issueList: [],
  hasAcceptWaitToAccept: false,
};
const workOrder = createSlice({
  name: 'workOrder',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(AllActions.actionWorkOrderInfo, (state, action) => {
      if (isNull(action.payload.issueList)) {
        state.issueList = [];
        return;
      }
      if (Array.isArray(action.payload.issueList)) {
        state.issueList = action.payload.issueList;
      }
    });
  },
});

export default workOrder.reducer;
